import posthog from 'posthog-js'
import { isBlacklisted } from './utils/is-blacklisted'

export const usePosthog = () => {
  const canRunPosthog = () => {
    if (typeof window === 'undefined') {
      return false
    }

    if (isBlacklisted(window.location.pathname)) {
      return false
    }

    return true
  }

  const trackEvent = ({
    name,
    eventProperties
  }: {
    name: string
    eventProperties?: any
  }) => {
    if (!canRunPosthog()) {
      return
    }
    posthog?.capture(name, eventProperties)
  }

  return {
    trackEvent,
    posthog
  }
}
